export const API_URL = String(process.env.API_URL)
export const REACT_APP_API_URL = String(process.env.REACT_APP_API_URL)